import { render } from "./DeleteTerms.vue?vue&type=template&id=c2924c4a&scoped=true"
import script from "./DeleteTerms.vue?vue&type=script&lang=js"
export * from "./DeleteTerms.vue?vue&type=script&lang=js"

import "./DeleteTerms.vue?vue&type=style&index=0&id=c2924c4a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2924c4a"]])

export default __exports__